<template>
<div v-if="$route.name == 'paymentLinkCheckoutSuccess'">
  <div class="flex items-center justify-center min-h-[90vh]">
    <div
      class="bg-white shadow-md rounded-xl p-6 text-center flex flex-col items-center justify-center relative">
      <!-- Header effect strip -->
      <div class="absolute top-0 left-0 w-full h-5 bg-[#092E87] rounded-t-xl"></div>
      <!-- Logo -->
      <img src="../../assets/images/fyxify-logo-rounded.svg" class="w-24 mb-6 mt-6" />
      <!-- Title -->
      <h1 class="text-5xl font-bold text-[#092E87] mb-4">Thank You</h1>
      <h4 class="text-2xl font-normal text-black mb-2">Congratulations!</h4>
      <p class="text-base text-gray-700">Successful Checkout: "Payment Processed Successfully".</p>
    </div>
  </div>
</div>
<div v-else-if="$route.name == 'paymentLinkCheckoutFailed' && !user">
  <div class="flex items-center justify-center min-h-[90vh]">
    <div
      class="bg-white shadow-md rounded-xl p-6 text-center flex flex-col items-center justify-center relative">
      <!-- Header effect strip -->
      <div class="absolute top-0 left-0 w-full h-5 bg-[#092E87] rounded-t-xl"></div>
      <!-- Logo -->
      <img src="../../assets/images/fyxify-logo-rounded.svg" class="w-24 mb-6 mt-6" />
      <!-- Title -->
      <h1 class="text-5xl font-bold text-[#092E87] mb-4">Payment Failed</h1>
      <p class="text-base text-gray-700">Failed Checkout: "Payment attempt was unsuccessful".</p>
    </div>
  </div>
</div>
</template>
<script>
import {
    mapActions,
    mapGetters,
} from "vuex";

export default {
    components: {
    },
    data() {
        return {
            user: localStorage.getItem("user") ?? null
        }
    },
    computed: {
        ...mapGetters(["paymentLinkCheckoutResponse"]),
    },

    watch: {
        paymentLinkCheckoutResponse: function () {
            setTimeout(() => {
                this.setSuccessResponse()    
            }, 500);
        },
    },

    mounted() {

        const query = this.$route.query;
        const is_from_mobile = localStorage.getItem("is_from_mobile", 0) ?? 0
        this.user = localStorage.getItem("user") ?? null
        // Check if param is missing
        if (!query.is_from_mobile && is_from_mobile == 1) {
            this.$router.replace({
                path: this.$route.path,
                query: {
                    ...this.$route.query,
                    is_from_mobile: '1'
                }
            });
        }

        if (this.$route.name == 'paymentLinkCheckoutSuccess') {
            this.paymentLinkCheckoutCall()
        } else if (this.$route.name == 'paymentLinkCheckoutFailed') {
            if (this.user) {
                this.$router.replace({
                    path: `/checkout/invoice/${this.$route.query.invoice_id}`,
                    query: {
                        is_from_mobile: is_from_mobile
                    }
                });
            }
        }
    },

    methods: {
        ...mapActions(["paymentLinkCheckout"]),

        paymentLinkCheckoutCall(){
            let payload = this.$route.query
            payload['payment_type'] = 'stripe_session'
            this.paymentLinkCheckout(payload)
        },

        setSuccessResponse() {
            if (this.$route.query.is_from_mobile == '1') {
                this.$router.replace({
                    name: 'checkoutSuccess',
                    query: {
                        is_from_mobile: Number(this.$route.query.is_from_mobile) === 1 ? 1 : 0
                    },
                });
            } else if (!this.user) {

            } else if (this.paymentLinkCheckoutResponse.job_type == 'mq') {
                this.$router.replace({path: `/quote/detail/${this.paymentLinkCheckoutResponse.job_id}`});
            } else if (this.paymentLinkCheckoutResponse.job_type == 'sar') {
                let val = localStorage.getItem("redirect_to") ?? ''

                if(val == 'job_invoice'){
                    this.$router.replace({path: `/job/invoice/${this.paymentLinkCheckoutResponse.job_id}`});

                }
                else{
                    this.$router.replace({path: `/job/detail/${this.paymentLinkCheckoutResponse.job_id}`});
                }
            }
        }

    }

}
</script>

